import React from 'react';

const CourseDetails = () => {
    return (
        <div className='pt-12 mb-24 container mx-auto'>
            <div className='text-center'>
                <img className='w-24 mx-auto' src="https://learnwithsumit.com/_next/static/media/peep1.f4841716.svg" alt="" />
                <h1 className='text-3xl font-bold mt-4'>এক নজরে ওয়েব ডিজাইন বাংলা কোর্স</h1>
                <p className='text-xl mt-2'>এই কোর্সে যা যা থাকছে</p>
            </div>


            <div className=''>
                <div className='lg:w-5/6 grid lg:grid-cols-3 md:grid-cols-2 justify-items-center  mx-auto shadow-lg rounded-md border mt-12  p-4'>


                    <div className=' p-8 border-b lg:border-r'>
                        <div className='transform transition duration-500 hover:scale-110'>
                            <div className='flex justify-center'>
                                <img className='w-16' src="https://phero-web.nyc3.cdn.digitaloceanspaces.com/website-prod-images/public/files/1607429634267.png" alt="" />

                            </div>
                            <h1 className='text-xl text-black mt-3 text-center'>এইটা কমপ্লিট ওয়েব ডেভেলপমেন্ট এর কোর্স:</h1>
                            <p className='text-sm text-gray-500 mt-2 text-center'>শূন্য থেকে একজন জুনিয়র ওয়েব ডেভেলপার হিসেবে চাকরি পাওয়ার জন্য যা যা লাগে তার সবকিছুই ধরে ধরে শিখানো</p>

                        </div>
                    </div>
                    <div className='  p-8  border-b lg:border-r'>
                        <div className='transform transition duration-500 hover:scale-110'>
                            <div className='flex justify-center'>
                                <img className='w-16' src="https://phero-web.nyc3.cdn.digitaloceanspaces.com/website-prod-images/public/files/1607429725146.png" alt="" />

                            </div>
                            <h1 className='text-xl text-black mt-3 text-center'>আনলিমিটেড সাপোর্ট:</h1>
                            <p className='text-sm text-gray-500 mt-2 text-center'>কোর্স চলাকালীন সময়ে ২৪ ঘন্টার মধ্যে তোমার যেকোন প্রশ্নের উত্তর দেয়া হবে (ছুটির দিন বাদে)। পেঁচগি মার</p>

                        </div>
                    </div>
                    <div className='  p-8 border-b'>
                        <div className='transform transition duration-500 hover:scale-110'>
                            <div className='flex justify-center'>
                                <img className='w-16' src="https://phero-web.nyc3.cdn.digitaloceanspaces.com/website-prod-images/public/files/1607429634267.png" alt="" />

                            </div>
                            <h1 className='text-xl text-black mt-3 text-center'>12 টি মডিউলে 135+ ভিডিও</h1>
                            <p className='text-sm text-gray-500 mt-2 text-center'>আপনারা যেন ধাপে ধাপে শিখতে পারেন সেজন্য পুরো কোর্সটি 12টি মডিউলে ও 135+ ভিডিওতে ভাগ করে সাজানো হয়েছে।</p>

                        </div>
                    </div>
                    <div className='  p-8 border-b lg:border-b-0 lg:border-r'>
                        <div className='transform transition duration-500 hover:scale-110'>
                            <div className='flex justify-center'>
                                <img className='w-16' src="https://phero-web.nyc3.cdn.digitaloceanspaces.com/website-prod-images/public/files/1607429634267.png" alt="" />

                            </div>
                            <h1 className='text-xl text-black mt-3 text-center'>12 টি মডিউলে 135+ ভিডিও</h1>
                            <p className='text-sm text-gray-500 mt-2 text-center'>আপনারা যেন ধাপে ধাপে শিখতে পারেন সেজন্য পুরো কোর্সটি 12টি মডিউলে ও 135+ ভিডিওতে ভাগ করে সাজানো হয়েছে।</p>

                        </div>
                    </div>
                    <div className='  p-8  border-b lg:border-b-0 lg:border-r'>
                        <div className='transform transition duration-500 hover:scale-110'>
                            <div className='flex justify-center'>
                                <img className='w-16' src="https://phero-web.nyc3.cdn.digitaloceanspaces.com/website-prod-images/public/files/1607429634267.png" alt="" />

                            </div>
                            <h1 className='text-xl text-black mt-3 text-center'>12 টি মডিউলে 135+ ভিডিও</h1>
                            <p className='text-sm text-gray-500 mt-2 text-center'>আপনারা যেন ধাপে ধাপে শিখতে পারেন সেজন্য পুরো কোর্সটি 12টি মডিউলে ও 135+ ভিডিওতে ভাগ করে সাজানো হয়েছে।</p>

                        </div>
                    </div>
                    <div className='  p-8 '>
                        <div className='transform transition duration-500 hover:scale-110'>
                            <div className='flex justify-center'>
                                <img className='w-16' src="https://phero-web.nyc3.cdn.digitaloceanspaces.com/website-prod-images/public/files/1607429634267.png" alt="" />

                            </div>
                            <h1 className='text-xl text-black mt-3 text-center'>12 টি মডিউলে 135+ ভিডিও</h1>
                            <p className='text-sm text-gray-500 mt-2 text-center'>আপনারা যেন ধাপে ধাপে শিখতে পারেন সেজন্য পুরো কোর্সটি 12টি মডিউলে ও 135+ ভিডিওতে ভাগ করে সাজানো হয়েছে।</p>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default CourseDetails;